import { CurrencyTextV2 } from "../currency-text-v2";
import { useTranslations } from "next-intl";

export type CompleteOrderDetailsV2Props = {
  price: string;
  currencyCode: string;
  orderId: string;
  showOrderId?: boolean;
};

export const CompleteOrderDetailsV2 = ({
  price,
  currencyCode,
  orderId,
  showOrderId = true,
}: CompleteOrderDetailsV2Props) => {
  const t = useTranslations("Checkout");

  return (
    <div
      data-testid="complete-order-details"
      className="flex flex-col items-center gap-1"
    >
      {showOrderId ? (
        <div className="text-center text-lg font-medium">
          {t("orderSection.order", { field: "order" })}: {orderId}
        </div>
      ) : null}
      <div className="text-center text-lg font-medium">
        {t("totalSection.totalPrice", { field: "totalPrice" })}
        :&nbsp;
        <CurrencyTextV2
          currencyCode={currencyCode}
          price={price}
          variant="completeOrderDetails"
        />
      </div>
    </div>
  );
};
